import { Tooltip, Popover } from 'bootstrap';
import * as td from '@eonasdan/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css';
import IMask from 'imask';
import moment from 'moment';
import 'moment/locale/cs';

class BootstrapExtension {
    initialize(naja) {
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
        naja.addEventListener('complete', this.init.bind(this));

        // nefungoval data-bs-toggle="collapse", tak toto je workaround
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(btn => {
            const sel = btn.getAttribute('data-bs-target');
            btn.removeAttribute('data-bs-toggle');
            btn.addEventListener('click', (e) => {
                const el = document.querySelector(sel);
                const inst = bootstrap.Collapse.getOrCreateInstance(el, { toggle: false });
                inst.toggle();
                e.preventDefault();
                e.stopImmediatePropagation();
            }, true);
        });
    }

    init(){
        this.initPopover();
        this.initSummaryTable();
        this.initDateTimePicker();
    }

    // --- helpers for datetime picker ---
    pad(n){ return String(n).padStart(2,'0'); }
    fmtDate(d){ return `${this.pad(d.getDate())}.${this.pad(d.getMonth()+1)}.${d.getFullYear()}`; }
    fmtDateTime(d){ return `${this.fmtDate(d)} ${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`; }

    parseNativeValue(raw, wantClock){
        if(!raw) return null;
        const s = raw.trim();
        // A) DD.MM.YYYY [HH:mm]
        const mDot = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
        if (mDot) {
            const [, dd, mm, yyyy, hh='0', mi='0', ss='0'] = mDot;
            return new Date(+yyyy, +mm-1, +dd, wantClock ? +hh : 0, wantClock ? +mi : 0, wantClock ? +ss : 0, 0);
        }
        // B) YYYY-MM-DD[ T]HH:mm(:ss)?
        const norm = s.replace(' ', 'T');
        const parts = norm.split('T');
        const [y,m,day] = (parts[0] || '').split('-').map(Number);
        if (!y || !m || !day) return null;
        let hh=0, mi=0, ss=0;
        if (wantClock && parts[1]) {
            const t = parts[1].split(':').map(v => parseInt(v,10) || 0);
            [hh, mi, ss] = [t[0]||0, t[1]||0, t[2]||0];
        }
        return new Date(y, m-1, day, hh, mi, ss, 0);
    }

    bindTdChangeToNative(el, picker){
        // převeď TD change na nativní input/change
        const fire = () => {
            el.dispatchEvent(new Event('input', { bubbles: true }));
            el.dispatchEvent(new Event('change', { bubbles: true }));
        };
        el.addEventListener('change.td', fire);
        if (picker && typeof picker.subscribe === 'function') {
            picker.subscribe(td.Namespace.events.change, fire);
        }
    }

    initDateTimePicker(){
        // vybereme všechny date/datetime-local (+ historický datetime)
        const inputs = document.querySelectorAll(
            'input[type="date"]:not([readonly]), input[type="datetime-local"], input[type="datetime"]'
        );

        inputs.forEach((el) => {
            // prevence dvojité inicializace
            if (el.dataset.tdInit === '1') return;

            // původní typ a hodnota (než přepíšeme type=text)
            const originalType = el.getAttribute('type'); // 'date' | 'datetime-local' | 'datetime'
            const wantClock = originalType !== 'date';    // u datetime/datetime-local zobraz hodiny
            const raw = (el.value || el.getAttribute('value') || '').trim();

            // .form-floating potřebuje placeholder, jinak to může vypadat "prázdně"
            if (el.closest('.form-floating') && !el.hasAttribute('placeholder')) {
                el.setAttribute('placeholder', ' ');
            }

            // vypnout nativní picker
            el.setAttribute('data-original-type', originalType);
            el.setAttribute('type', 'text');

            // zkus naparsovat výchozí hodnotu (ať už je ve formátu Y-m-d / Y-m-dTHH:mm / dd.MM.yyyy / dd.MM.yyyy HH:mm)
            const initialJsDate = this.parseNativeValue(raw, wantClock);

            const picker = new td.TempusDominus(el, {
                display: {
                    icons: {
                        type: 'icons',
                        time: 'bi bi-clock',
                        date: 'bi bi-calendar',
                        up: 'bi bi-chevron-up',
                        down: 'bi bi-chevron-down',
                        previous: 'bi bi-chevron-left',
                        next: 'bi bi-chevron-right',
                        today: 'bi bi-calendar-check',
                        clear: 'bi bi-trash',
                        close: 'bi bi-xmark'
                    },
                    sideBySide: wantClock,
                    components: {
                        calendar: true,
                        clock: wantClock,
                        seconds: false,
                        useTwentyfourHour: true,
                    },
                    theme: 'light',
                },
                localization: {
                    locale: 'cs',
                    // použij pevný formát, který chceš ukazovat uživateli
                    format: wantClock ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy',
                },
                useCurrent: false,
                // defaultDate stačí, ale níže stejně "natvrdo" nastavíme hodnotu i do .value
                defaultDate: initialJsDate || undefined
            });

            if (wantClock) {
                const momentFormat = 'DD.MM.YYYY HH:mm';

                IMask(el, {
                    mask: Date,
                    pattern: momentFormat,
                    lazy: true,
                    autofix: true,

                    format: date => moment(date).format(momentFormat),
                    parse: str => moment(str, momentFormat),

                    blocks: {
                        YYYY: {
                            mask: IMask.MaskedRange,
                            from: 1970,
                            to: 2050
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12
                        },
                        DD: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31
                        },
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23
                        },
                        mm: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59
                        }
                    }
                });
            } else {
                IMask(
                    el,
                    {
                        mask: Date,
                        lazy: true,
                        autofix: true,
                        min: new Date(1970, 0, 1),
                        max: new Date(2100, 0, 1),
                    }
                );
            }

            // pokud je vstup naplněn, hned jej přeformátuj do zvoleného formátu a ZOBRAZ
            if (initialJsDate) {
                picker.dates.setValue(new td.DateTime(initialJsDate));
                el.value = wantClock ? this.fmtDateTime(initialJsDate) : this.fmtDate(initialJsDate);
                // hned vystřel i události pro navazující logiku
                el.dispatchEvent(new Event('input', { bubbles: true }));
                el.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // bridge TD změn na nativní eventy
            this.bindTdChangeToNative(el, picker);

            // reference a flag
            el._td = picker;
            el.dataset.tdInit = '1';
        });
    }

    initSummaryTable(){
        const table = document.querySelector('.summary-table');
        if (!table) return;

        table.addEventListener('click', (e) => {
            const tr = e.target.closest('tr[data-toggle="collapse"]');
            if (!tr) return;

            const level = +tr.dataset.level;
            const group = tr.dataset.group;
            const expanded = tr.getAttribute('aria-expanded') === 'true';
            tr.setAttribute('aria-expanded', expanded ? 'false' : 'true');

            // jdi po následujících sourozencích, dokud nenarazíš na stejné/nižší level
            let r = tr.nextElementSibling;
            while (r) {
                const rLevel = +r.dataset.level || 99;
                if (rLevel <= level) break;

                if (expanded) {
                    // při zavření skryj všechny potomky včetně rekurzivních
                    r.classList.add('hidden');
                    if (r.dataset.toggle === 'collapse') r.setAttribute('aria-expanded', 'false');
                } else {
                    // při otevření ukaž jen PŘÍMÉ děti
                    if (r.dataset.parent === group) r.classList.remove('hidden');
                }
                r = r.nextElementSibling;
            }
        });
    }

    hidePopover(){
        $('.tooltip').remove();
    }

    initPopover() {
        this.hidePopover();

        // Tooltip
        var tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        var tooltipList = tooltipTriggerList.map(
            function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl, {trigger : 'hover', html: true});
            }
        );

        // Popover
        var popoverTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="popover"]')
        );
        var popoverList = popoverTriggerList.map(
            function (popoverTriggerEl) {
                return new Popover(popoverTriggerEl, {trigger : 'hover focus', html: true});
            }
        );
    }
}

export default BootstrapExtension;
